function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';
import { SvgIcon } from '@mui/material';
import { jsx as _jsx } from "react/jsx-runtime";
var SortDown = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/_jsx(SvgIcon, _extends({
    "data-testid": "SortDownIcon"
  }, props, {
    ref: ref,
    children: /*#__PURE__*/_jsx("path", {
      d: "M11 17.153V3h2v14.153l1.825-1.86a.968.968 0 0 1 1.388 0c.383.39.383 1.023 0 1.414L12 21l-4.213-4.293a1.013 1.013 0 0 1 0-1.414.968.968 0 0 1 1.388 0L11 17.153z"
    })
  }));
});
SortDown.displayName = 'SortDownIcon';
export default SortDown;